import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shared-siriema',
  templateUrl: './shared-siriema.component.html'
})
export class SharedSiriemaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
